import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_NEWS } from './router';

menuRegistry.registerMenu([
    {
        parent: 'General',
        key: 'News',
        name: 'News',
        icon: 'fas fa-newspaper',
        route: { name: ROUTE_NAME_NEWS.INDEX }
    }
]);

export default registerRouteForModule(router);
